let pos_comp_TableSelectModal = require("../../templates/pos/comp/TableSelectModal.handlebars");
let pos_comp_TableSelectList = require("../../templates/pos/comp/TableSelectList.handlebars");
let Backbone = require("backbone");
let _ = require("underscore");
let BasePagingModel = require("../../model/BasePagingModel.js");

let main = function () {
    return Backbone.View.extend({

        events: {
            "click .pageUp": "onPrev",
            "click .pageDown": "onNext",
            "click .tableSelectList li": "onSelectItem",
            "mouseover .tableSelectList li": "onMouseOver",
            "mouseout .tableSelectList li": "onMouseOut",
            "hidden.bs.modal": "onClose"
        },

        initialize: function (params) {
            this.model = new BasePagingModel(params);
            this.model.set({pageSize: 20});
        },

        /**
         * Triggered when modal closing
         */
        onClose: function(){
            //this.$el.modal('hide');
        },

        onPrev: function () {
            this.model.prev();
            this.renderTableList();
        },

        onNext: function () {
            this.model.next();
            this.renderTableList();
        },

        onMouseOver: function (evt) {
            $(evt.target).addClass("selected");
        },

        onMouseOut: function (evt) {
            $(evt.target).removeClass("selected");
        },

        onSelectItem: function (evt) {
            if($(evt.currentTarget).hasClass("disabled")) {
                return false;
            }
            var tableId = $(evt.currentTarget).data("id"),
                table = this.model.get("collection").get(tableId);
//                if (POS.getCurrentTable() && tableId != POS.getCurrentTable().id) {
//                    this.trigger("selectTable", table);
//                }
            this.model.set({"currentTable": table});
            this.$el.modal('hide');
            this.trigger("selectTable", this.model.get("currentTable"));
            //Because of the fade effect
            _.delay(_.bind(this.remove, this), 500);
        },

        render: function (table) {
            var currentTableName = table ? table.get("name") : "";
            this.setElement(pos_comp_TableSelectModal({
                currentTableName: currentTableName
            }));
            this.renderTableList();
            this.$el.modal();
            return this;
        },

        renderTableList: function () {
            this.$(".listContainer").html(pos_comp_TableSelectList({
                tableList: this.model.getPageCollection().toJSON(),
                disabledNext: this.model.hasNext(),
                disabledPrev: this.model.hasPrev()
            }));
        }
    });
};

let exportedValue = main();
export default exportedValue;


// WEBPACK FOOTER //
// ./src/view/comp/TableSelectModalView.js